// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__pihuF","dragIcon":"SortableItem_dragIcon__1QLUz","disabled":"SortableItem_disabled__1orTz"};